export default {
  setUser(state, { user, token }) {
    state.user = user;
    state.token = token;
  },
  logout(state) {
    state.user = null;
    state.token = null;
  },
};
